$(document).ready(function () {
  $(".mobile_menu .list-menu.list-menu--inline li:first-child #MegaMenu-Content-1 ul li:not(:first-child) span").click(function () {
    var targetList = $(this).next("ul");
    targetList.slideToggle(500);
    if (targetList.is(":visible")) {
      $(this).toggleClass("active");
    } else {
      $(this).removeClass("active");
    }
    $(".mobile_menu .list-menu.list-menu--inline li:first-child #MegaMenu-Content-1 ul li:not(:first-child) ul")
      .not(targetList)
      .slideUp(500);
    $(".mobile_menu .list-menu.list-menu--inline li:first-child #MegaMenu-Content-1 ul li:not(:first-child) span")
      .not(this)
      .removeClass("active");
  });
});

jQuery(document).ready(function ($) {
  $('.newsletter .product-popup-modal__button').click(function() { 
    $('header').addClass('newsletter');
    if ($('header').hasClass('light_header')) { 
      $('header').removeClass('scrolled-up');    
    } else {
      $('header').addClass('light_header');
    }
  });
  $('.diamond-content').on('click', function () {
        $('.footer-newsletter-modal').attr('open', '');
    });
  $('img.svg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    $.get(imgURL, function (data) {
        var $svg = $(data).find('svg');
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);
        $svg.find('circle').on('click', function () {
            $(this).attr('fill', 'blue');
        });
    }, 'xml');
  });
  /*scrolled up sticky*/
  if ($('header').length > 0) {
    var lastScrollTop = 0; 
    var $header = $('header');
      $(window).on('scroll', function() {
          var scrollTop = $(this).scrollTop();         
          if (scrollTop > lastScrollTop) { 
              $header.removeClass('scrolled-up');
          } else if (scrollTop < lastScrollTop && scrollTop !== 0) { 
              $header.addClass('scrolled-up');
          }
          if (scrollTop === 0) {
              $header.removeClass('scrolled-up');
          }
          lastScrollTop = scrollTop;        
      });
    }
  /* Home banner video mute/unmute function start here */
  if($('a#unmute').length > 0){
      $(document).on('click', 'a#unmute', function() {
        var video = document.getElementById("hero-video");
        var volumeIcon = document.querySelector('.icon-button-volume');
        var muteIcon = document.querySelector('.icon-button-volume-mute');
        if (video.muted) {
            video.muted = false;
            volumeIcon.style.display = 'none';
            muteIcon.style.display = 'block';
        } else {
            video.muted = true;
            volumeIcon.style.display = 'block';
            muteIcon.style.display = 'none';
        }
      });
    }
  
    if($('.filter-box').length > 0) {
      $('.filter-box').click(function() {
          $('.filter-box span').toggleClass('active');
          $('#filter-list').toggle();
      });
    }
  
    var currentlyActive = null;
    function handleToggleClass(element) {
        var isActive = $(element).hasClass('active');
        if (currentlyActive && currentlyActive !== element) {
            $(currentlyActive).removeClass('active');
        }
        if (isActive) {
            $(element).removeClass('active');
            currentlyActive = null;
        } else {
            $(element).addClass('active');
            currentlyActive = element;
        }
    }
	if ($('.facet-filters__label').length > 0) {
		$(document).on('click', '.facet-filters__label', function () {
			var sortFilter = document.querySelector('.sort_filter');
			sortFilter.style.display = (sortFilter.style.display === 'none') ? 'block' : 'none';
            handleToggleClass(this);
		});
	}
	if ($('.facets__heading').length > 0) {
		$(document).on('click', '.facets__heading', function () {
			var refineFilter = document.querySelector('.refine_filter');
			refineFilter.style.display = (refineFilter.style.display === 'none') ? 'block' : 'none';
            handleToggleClass(this);
		});
	}
    if ($('.mobile-filter-btn').length > 0) {
      $('.mobile-filter-btn button').click(function(){
          $('aside.facets-wrapper').toggle();
      });
    }
  
	if ($('.facet-filters__label').length > 0 || $('.facets__heading').length > 0) {
		$(document).on('click', function () {
			var sortToggle = document.querySelector('.facet-filters__label');
			var sortFilter = document.querySelector('.sort_filter');
			var refineToggle = document.querySelector('.facets__heading');
			var refineFilter = document.querySelector('.refine_filter');
			var isClickInside = sortToggle.contains(event.target) || sortFilter.contains(event.target);
			var isClickInside1 = refineToggle.contains(event.target) || refineFilter.contains(event.target);
			if (!isClickInside) {
				sortFilter.style.display = 'none';
			}
			if (!isClickInside1) {
				refineFilter.style.display = 'none';
			}
		});
	}
	// Close the announcement bar when the close button is clicked
	if ($('.announcement-bar .close').length > 0) {
		$(".announcement-bar .close").click(function () {
			$('.announcement-bar').fadeToggle();            
			$(window).off('scroll.announcementScroll');
		});
	}
    if ($('.diamond-outer span a').length > 0) {
        $('.diamond-outer span a').click(function() {
            $('.diamond-outer').toggleClass('active');
            $('.diamond-content').fadeToggle();
        });
    }
    
    if ($('.qs_btn a').length > 0) {
      $('.qs_btn a').click(function() {
        const product = $(this).closest('.box');
        const sizeDiv = product.find('.quickshop_outer');
        const QsMC = product.find('.content.main_content,.content.fullwidth_content');
        $('.quickshop_outer').not(sizeDiv).fadeOut(400);
        $('.content.main_content,.content.fullwidth_content').not(QsMC).removeClass('active');
        $('.qs_btn a').not(this).text('Shop');
        sizeDiv.fadeToggle();
        QsMC.toggleClass('active');
        if(QsMC.hasClass('active')) {
          $(this).text('Close');
        } else {
          $(this).text('Shop');
        }
      });
    }
    if ($('.qs_size a').length > 0) {
      $('.qs_size a').click(function() {
        const product = $(this).closest('.box');
        const sizeDiv = product.find('.quick-custom-size');
        $('.quick-custom-size').not(sizeDiv).slideUp();
        sizeDiv.slideToggle();
      });
    }  
	// Footer scroll logic for announcement bar
	var announcementBar = $('.announcement-bar');
	var footer = $('footer');
	if(announcementBar.length > 0) {
		$(window).on('scroll.announcementScroll', function () {
			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var footerOffsetTop = footer.offset().top;

			if (scrollTop + windowHeight > footerOffsetTop) {
				announcementBar.fadeOut();
			} else {
				announcementBar.fadeIn();
			}
		});
	} 
    if ($('.mprod_carousel').length > 0) {
      function mprodCarousel() {  
        var swiper = new Swiper(".mprod_carousel", {
          speed: 1000,
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      }
      mprodCarousel();
    }
    if ($('.product-item .colour_variant label').length > 0) {
      $('body').on('click', '.product-item .colour_variant label', function(e) {
        var handle = $(this).parent().find('input').attr('data-handle');
        var current_ele = $(this).closest('.product-item');
        var productItemContainer = current_ele.closest('.grid__item');
        var colorOptions = current_ele.find('.colour_variant li');
        $.ajax({
            url: '/products/' + handle + '?view=alternate',
            type: 'GET',
            success: function(data) {
              var newContent = $(data).find('.product-item').html();
              current_ele.html(newContent);

              var newHandle = productItemContainer.find('.colour_variant input[checked]').attr('data-handle');                  
              productItemContainer.find('.colour_variant ul').empty();
              colorOptions.each((index, el) => {
                var $el = $(el);
                productItemContainer.find('.colour_variant ul').append($el);
              });
              
              productItemContainer.find('.colour_variant input').each((index, el) => {
                $(el).removeAttr('checked');
                $(el).siblings().css('border', 'none');
              });
              productItemContainer.find('.colour_variant input').each((index, el) => {
                if ($(el).data('handle') == newHandle) {
                  $(el).attr('checked', 'checked');
                  $(el).siblings().css('border', '1px solid #431C28');                
                }
              });
              
              if ($('.mprod_carousel').length > 0) {
                mprodCarousel();
              }
            }
        });
        e.stopPropagation();
      });
    }
    /*special project loop slider event handling*/
    function bindQuickShopEvents() {
        // Bind for duplicated slides only
        $(document).off('click', '.swiper-slide-duplicate .qs_btn a').on('click', '.swiper-slide-duplicate .qs_btn a', function(e) {
            e.preventDefault();
            const product = $(this).closest('.box');
            const sizeDiv = product.find('.quickshop_outer');
            const QsMC = product.find('.content.main_content');
            $('.quickshop_outer').not(sizeDiv).slideUp();
            sizeDiv.slideToggle();
            QsMC.toggleClass('active');
        });
    
        $(document).off('click', '.swiper-slide-duplicate .qs_size a').on('click', '.swiper-slide-duplicate .qs_size a', function(e) {
            e.preventDefault();
            const product = $(this).closest('.box');
            const sizeDiv = product.find('.quick-custom-size');
            $('.quick-custom-size').not(sizeDiv).slideUp();
            sizeDiv.slideToggle();
        });
    }
    if ($('.deering-at-title').length > 0) {
      $(".deering-at-title").click(function () {
        $(this)
          .toggleClass("active")
          .next(".deering-at-tab")
          .slideToggle()
          .parent()
          .siblings()
          .find(".deering-at-tab")
          .slideUp()
          .prev()
          .removeClass("active");
      });
    }
    if ($('.image_carousel').length > 0) {
        function ImgCarousel() {
            var swiper = new Swiper(".image_carousel", {
                speed: 1000,
                loop: true,
                autoplay: true,
                behavior: 'smooth',
                slidesPerView: 3,
                watchSlidesProgress: true,
                spaceBetween: 0,
                pagination: {
                    el: '.slider__pagination',
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 3.5,
                    },
                    1024: {
                        slidesPerView: 3.5,
                        spaceBetween: 0,
                    },
                    767: {
                        slidesPerView: 2.5,
                        spaceBetween: 0,
                    },
                    300: {
                        slidesPerView: 1.4,
                        spaceBetween: 0,
                    }
                },
                noSwipingSelector: 'a',
                loopAdditionalSlides: 1,
                autoHeight: true,
                on: {
                    slideChangeTransitionStart: function(swiper) {
                        let $wrapperEl = swiper.$wrapperEl;
                        let params = swiper.params;
                        $wrapperEl.children('.' + (params.slideClass) + '.' + (params.slideDuplicateClass))
                            .each(function() {
                                let idx = this.getAttribute('data-swiper-slide-index');
                                this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
                            });
                    },
                    slideChangeTransitionEnd: function(swiper) {
                        swiper.slideToLoop(swiper.realIndex, 0, false);
                    },
                    // Re-bind event handlers after slides are updated
                    update: function() {
                        bindQuickShopEvents();
                    }
                }
            });
            // Initial event binding
            bindQuickShopEvents();
        }
        ImgCarousel();
    }
    if ($('.slider_banner').length > 0) {
      function CsbCarousel() {
        var swiper = new Swiper(".slider_banner", {
            speed: 1000,
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            mousewheel: {
                invert: false,
                releaseOnEdges: false,
            },
            on: {
              reachEnd: function () {
                  setTimeout(function() {
                      window.addEventListener('wheel', handleWindowScroll, { passive: false });
                  }, 500);
              },
              fromEdge: function () {
                  window.removeEventListener('wheel', handleWindowScroll);
              }
            }
        });
      }
      CsbCarousel();
    }
    function handleWindowScroll(event) {
        if (event.deltaY > 0 && (window.innerHeight + window.scrollY) >= document.body.offsetHeight) { // Scroll down and reached bottom
            window.scrollBy({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        } else if (event.deltaY < 0 && window.scrollY === 0) { // Scroll up and at the top
            event.preventDefault();
            const swiperContainer = document.querySelector('.swiper-container');
            swiperContainer.swiper.slidePrev();
        }
    }
    if ($('.product_carousel').length > 0) {
      function ProdCarousel() {
        var swiper = new Swiper(".product_carousel", {
            speed: 1000,
            loop: false,
            behavior: 'smooth',
            slidesPerView: 3,            
            spaceBetween: 0,
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3.53,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3.53,
                    spaceBetween: 20,
                },
                767: {
                    slidesPerView: 3.53,
                    spaceBetween: 15,
                },
                300: {
                    slidesPerView: 2.3,
                    spaceBetween: 15,
                }
            }
        });
      }
      ProdCarousel();
    }
    if ($('.collection_carousel').length > 0) {
      function CollectionCarousel() {
        var swiper = new Swiper(".collection_carousel", {
            direction: 'horizontal',
            speed: 300,
            loop: false,
            behavior: 'smooth',
            slidesPerView: 3,
            spaceBetween: 0,
            pagination: false,
            mousewheel: {
                forceToAxis: true,
                eventsTarget: '.collection_carousel'
            },
            breakpoints: {
                1200: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 0,
                },
                767: {
                    slidesPerView: 2.5,
                    spaceBetween: 0,
                },
                300: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            },         
              mousewheel: {
                  invert: false,
                  releaseOnEdges: false,
              },
              on: {
                reachEnd: function () {
                    setTimeout(function() {
                        window.addEventListener('wheel', handleWindowScroll, { passive: false });
                    }, 500);
                },
                fromEdge: function () {
                    window.removeEventListener('wheel', handleWindowScroll);
                }
            }
        });
      }
      CollectionCarousel();
    }
    function handleWindowScroll(event) {
        if (event.deltaY > 0 && (window.innerHeight + window.scrollY) >= document.body.offsetHeight) { 
            window.scrollBy({
                top: window.innerHeight,
                behavior: 'smooth'
            });
        } else if (event.deltaY < 0 && window.scrollY === 0) {
            event.preventDefault(); 
            const swiperContainer = document.querySelector('.swiper-container');
            swiperContainer.swiper.slidePrev();
        }
    }  
    if ($('.quick_shop_area').length > 0) {
      function QsaCarousel() {
          var swiper = new Swiper(".quick_shop_area", {
            speed: 1000,
            loop: false,
            behavior: 'smooth',
            slidesPerView: 3,            
            spaceBetween: 0,
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
                767: {
                    slidesPerView: 2.5,
                    spaceBetween: 14,
                },
                300: {
                    slidesPerView:  2.5,
                    spaceBetween: 14,
                }
            }
          });
        }
        QsaCarousel();
    }  
    if ($('.blog-products_slider').length > 0) {
       function bProdCarousel() {
          var swiper = new Swiper(".blog-products_slider", {
            speed: 1000,
            loop: false,
            behavior: 'smooth',
            slidesPerView: 6,            
            spaceBetween: 15,
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 6,
                },
                1024: {
                    slidesPerView: 6,
                },
                767: {
                    slidesPerView: 2.5,                  
                },
                300: {
                    slidesPerView: 2.5,
                }
            }
          });
        }
        bProdCarousel();
      }
      if ($('.singprod_carousel').length > 0) {
        function singprodCarousel() {
          var swiper = new Swiper(".singprod_carousel", {
              speed: 1000,
              loop: false,
              slidesPerView: 1,
              spaceBetween: 0,
              pagination: false,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
          });
        }
        singprodCarousel();
      }
      //product single sticky add to cart
      if($('.sticky-product-info').length > 0){
          var $stickyElement = $('.sticky-product-info');
          var $mediaWrapper = $('.product__media-wrapper');
          if ($stickyElement.length === 0 || $mediaWrapper.length === 0) {
            console.error('Required elements not found in the DOM');
            return;
          }
          function getStickyElementPosition() {
              return $stickyElement.offset().top;
          }
          function getStickyElementHeight() {
              return $stickyElement.innerHeight();
          }
          var totalheight = getStickyElementPosition() + getStickyElementHeight();
          function getMediaWrapperBottom() {
            return $mediaWrapper.offset().top + $mediaWrapper.outerHeight()-totalheight;
          }
          function handleScroll() {
            /*console.log($(window).scrollTop());
            console.log(getMediaWrapperBottom());
            console.log(totalheight);
            console.log(getStickyElementHeight());*/
            if ($(window).scrollTop() >= getMediaWrapperBottom()) {
              $stickyElement.addClass('non-sticky');
            } else {
              $stickyElement.removeClass('non-sticky');
            }
          }
          // Log the current position of the sticky element
          //console.log("Current position of sticky element:", getStickyElementPosition());
          // Listen to scroll event
          $(window).on('scroll', handleScroll);
           //console.log("Current position on scroll:", getStickyElementPosition());
          // Initial check in case the page is already scrolled
          handleScroll();
      }
      if($('.size_variant').length > 0) {
      $(document).on('click', '.size_variant li', function() {
        var $this = $(this);
        if ($this.hasClass('out-of-stock')) {
          return;
        }
        var $ul = $this.closest('ul');
        var formId = $ul.data('form');
        var variantId = $this.data('value');
        var $form = $('form#' + formId);
        $form.find('input[name=id]').val(variantId);
        $form.find('button[type=submit]').click();
     });
    }
    if($('#showroom .nested-tab_head').length > 0) {
    $('#showroom .nested-tab_head li').click(function() {
        const nestedTabId = $(this).attr('rel');
        $('#showroom .nested-tab_content').hide();
        $('#' + nestedTabId).fadeIn();
        $('#showroom .nested-tab_head li').removeClass('active');
        $(this).addClass('active');
    });
    }
    if ($('.video_area video').length > 0) {
        var video = document.querySelector('.video_area video');
        var button = document.querySelector('.watch_video');
        if (video && button) {
            button.addEventListener('click', function() {
                if (video.paused) {
                    video.play();
                    button.textContent = 'Pause video';
                } else {
                    video.pause();
                    button.textContent = 'Watch video';
                }
            });
        }
     }
    if($('.full-width-video video').length > 0) {
      var video = document.querySelector('.full-width-video video');
      var button = document.querySelector('.full-width-video a.play');
      if (video && button) {
        button.addEventListener('click', function() {
          if (video.paused) {
            video.play();
            button.textContent = 'Pause video';
          } else {
            video.pause();
            button.textContent = 'Watch video';
          }
      });
    }    
  }
  // Find the header anchor with the specified class and get its text
  var headerText = $('header .desktop a[href="/account/"].account-top').text();
   $('a[href="/account"]').text(headerText);
  
  if($('details.mega-menu').length > 0) {
  /* megamenu on click mobile js */
    var lastClickedMenu = null;
    $('details.mega-menu summary > span,.header__icon--search, .current-currency').on('click', function() {
        var $header = $('header');
        var $currentMenu = $(this);
        // Check if the same menu is clicked twice
        if (lastClickedMenu && lastClickedMenu.is($currentMenu)) {
            // If the class is already present, remove it
            if ($header.hasClass('hdr-transparent')) {
                $header.removeClass('hdr-transparent');
            } else {
                $header.addClass('hdr-transparent');
            }
            // Reset lastClickedMenu
            lastClickedMenu = null;
        } else {
            // Otherwise, add the class and set the last clicked menu
            $header.addClass('hdr-transparent');
            lastClickedMenu = $currentMenu;
        }
      });
    }
    /*mobile deskop class toggle*/
    function handleElementRemoval() {
          var isMobile = window.innerWidth <= 989;
          if (isMobile) {
              $('.desktop').remove();
          } else {
              $('.mobile').remove();
          }
      }
      handleElementRemoval();
     /* $(window).on('resize', function() {
          handleElementRemoval();
      });*/
  
    /*desktop specific js*/
    if ($(window).width() > 990) {
    // Scroll logic for banner_logo
    $('.right-menu.mobile').remove();
    var bannerLogo = $('.banner_logo');
    $(window).on('scroll', function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 0) {
          bannerLogo.fadeOut();
      } else {
          bannerLogo.fadeIn();
      }
    });
    //megamenu js
    /*let items = document.querySelectorAll(".mega-menu");
    let header = document.querySelector('header');
    let currentItemIndex;
    items.forEach((item, itemIndex) => {
      const content = item.querySelector(".mega-menu__content");
      item.addEventListener("mouseover", () => {
        if (
          (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
          (currentItemIndex && currentItemIndex !== itemIndex)
        ) {
          items[currentItemIndex].removeAttribute("open");
        }
        currentItemIndex = itemIndex;
        item.setAttribute("open", true);
      });
      item.addEventListener("mouseleave", () => {
        let close = true;
        const closeTimeout = setTimeout(() => {
          if (close) item.removeAttribute("open");
        }, 500);
        // Ensure these event listeners are only attached once per item
        content.addEventListener("mouseover", () => {
          close = false;
        });
        item.addEventListener("mouseover", () => {
          clearTimeout(closeTimeout);
        });
        content.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });
      });*/
     $('details.mega-menu').on('toggle', function() {
        if ($(this).prop('open')) {
            $('header').addClass('hdr-transparent');
        } else {
            $('header').removeClass('hdr-transparent');
        }
    });
    $('.currency_bar, .currency-megamenu,.header__search').on('toggle', function() {
        $('header').toggleClass('hdr-transparent');
    });
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.currency_bar, .currency-megamenu,.header__search').length) {
            $('header').removeClass('hdr-transparent');
        }
    });
     /*$('details.mega-menu,.currency_bar,.currency-megamenu').click(function() {          
          $('.header__search details').removeAttr('open');
          $('body').removeClass('overflow-hidden');
          $('header').addClass('hdr-transparent');
        }, function() {
          $('header').removeClass('hdr-transparent');
        }
      );    */  
      $('.close-menu').click(function() {
          $('header').removeClass('hdr-transparent');
      })
      
      /*Tab content js*/
      $(".v-tab_content").hide();
      $(".v-tab_content:first").show();
      // Function to show the tab from the URL hash
      function showTabFromHash() {
          var hash = window.location.hash;
          if (hash) {
              $(".v-tab_content").hide();
              $(hash).show();
              $(".v-tab_tab-head a").removeClass("active");
              $(".v-tab_tab-head a[href='" + hash + "']").addClass("active");
  
              // Dynamically calculate the offset
              /*var headerHeight = $(".information.desktop").css("padding-top");
              headerHeight = parseInt(headerHeight, 10); 
  
              var bannerHeight = 0;
              if ($(".custom_banner_inner").length) {
                  bannerHeight = $(".custom_banner_inner").outerHeight();
              }
  
              var totalOffset = headerHeight + bannerHeight;
              var targetOffset = $(hash).offset().top - totalOffset;
              $('html, body').animate({ scrollTop: targetOffset }, 0);*/              
              var headerHeight = $(".header").outerHeight() || 0;
              var targetOffset = $(hash).offset().top - headerHeight;
              $('html, body').animate({ scrollTop: targetOffset }, 500);
          }
        }
        // Click event for tab navigation links
        $(".v-tab_tab-head li a:not(:last-child)").click(function(event) {
            event.preventDefault();
            var activeTab = $(this).attr("href");
            window.location.hash = activeTab; 
            showTabFromHash();
        });
        // Check if there's a hash in the URL on page load
        if (window.location.hash) {
            showTabFromHash();
        }
        // Listen for hash changes in the URL
        $(window).on("hashchange", function() {
            showTabFromHash();
        });
        // Adjust scroll position on page load after everything is rendered
        $(window).on("load", function() {
            if (window.location.hash) {
                setTimeout(function() {
                    showTabFromHash();
                }, 100); 
            }
       });
      // Show currency mega menu on hover
       /* $('.currency_bar').hover(
    function() {
        $('.currency-megamenu').stop(true, true).fadeIn(300); // Fade in over 300 milliseconds
    },
    function() {              
        setTimeout(function() {
            if (!$('.currency-megamenu').is(':hover')) {
                $('.currency-megamenu').stop(true, true).fadeOut(300); // Fade out over 300 milliseconds
            }
        }, 200);
    }
);

        // Show currency mega menu on hovercurrent-currency
        $('.currency-megamenu').hover(
            function() {
                $(this).show(); 
            },
            function() {               
                setTimeout(function() {
                    $('.currency-megamenu').hide();
                }, 200); 
            }
        );*/
      $('.currency_bar').on('click', function() {
          $('.currency-megamenu').stop(true, true).fadeToggle(300);
      });
      $(document).on('click', function(e) {
          if (!$(e.target).closest('.currency_bar, .currency-megamenu').length) {
              $('.currency-megamenu').fadeOut(300);
          }
      });

      if ($('.at-title').length > 0) {
      $(".at-title").click(function () {
        $(this)
          .toggleClass("active")
          .next(".at-tab")
          .slideToggle()
          .parent()
          .siblings()
          .find(".at-tab")
          .slideUp()
          .prev()
          .removeClass("active");
      });
    }
    }
    else
    { /*mobile specific js*/
    if ($('.grid__item.video').length > 0) {
        var imageHeight = $('.full_col_image .mobile img').height();
        $('.video video').height(imageHeight);
    }
    // Check if .currency_bar exists
    if ($('.currency_bar').length > 0) {
        // Toggle the currency mega menu on click
        $('.currency_bar, .currency-megamenu .close-menu').on('click', function() {
            $('.currency-megamenu').toggle();
        });  
       // Hide currency mega menu if clicking outside of it
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.currency_bar, .currency-megamenu').length) {
                $('.currency-megamenu').hide();
            }
        });
    }
    $('.mobile-filter-btn button').click(function() {      
      $('header').toggleClass('fillter fixed scrolled-up'); 
      });  
    if ($('.at-title').length > 0) {
      $(".at-title").click(function () {
        $(this)
          .toggleClass("active")
          .next(".at-tab")
          .slideToggle()
          .parent()
          .siblings()
          .find(".at-tab")
          .slideUp()
          .prev()
          .removeClass("active");
      });
    }
    $('.right-menu.desktop').remove();
    function isFooterVisible() {
        var footerTop = $('footer').offset().top;
        var footerBottom = footerTop + $('footer').outerHeight();
        var windowBottom = $(window).scrollTop() + $(window).height();

        return footerTop < windowBottom && footerBottom > $(window).scrollTop();
    }
    //sticky js for mobile
    if($('.sticky-product-info.non-sticky').length > 0){
    var $stickyInfo = $('.sticky-product-info.non-sticky');
    var stickyHeight = $stickyInfo.outerHeight();
    var className = 'mobcart-white-bg'; 
    var $howWearOuter = $('.how_wear_outer');
    var $productInfoWrapper = $('.product__info-wrapper');
    var productInfoWrapperTop = $productInfoWrapper.offset().top;
    //var behindClass = 'behind';
    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop();
        var stickyBottom = scrollTop + stickyHeight;
        if (scrollTop >= stickyHeight) {
            $stickyInfo.addClass(className);
        } else {
            $stickyInfo.removeClass(className);
        }
    }); 
    }
    /*cart js*/
    $('.header__icon--cart').click(function() {
        var $cartDrawer = $('cart-drawer');
        setTimeout(function() { 
            if ($cartDrawer.hasClass('active')) {
                $('header').addClass('cart-opn');
                $('header').removeClass('hdr-transparent');
            }
        }, 100);
    });

     var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if ($(mutation.target).hasClass('active')) {
                $('header').addClass('cart-opn');
            } else {
                $('header').removeClass('cart-opn');
            }
        });
    });

    // Start observing the cart drawer for attribute changes
    var $cartDrawer = $('cart-drawer')[0];
    observer.observe($cartDrawer, { attributes: true });
      
    /* mobile footer nav scroll to has */
    var headerHeight = $('header').outerHeight(); 
    $('.footer-menu ul a[href*="#"]').on('click', function(event) {
        event.preventDefault();
        var fullUrl = this.href;
        var targetId = this.hash.substring(1);
        var currentUrl = window.location.href.split('#')[0];
        var linkUrl = fullUrl.split('#')[0];
        if (currentUrl === linkUrl) {
            scrollToHash(this.hash);
            if (history.pushState) {
                history.pushState(null, null, fullUrl);
            } else {
                window.location.hash = targetId;
            }
        } else {
            window.location.href = fullUrl;
        }
    });
    function scrollToHash(hash) {
        var targetId = hash.substring(1);
        var $targetElement = $('#' + targetId);
        if ($targetElement.length) {
            $('html, body').animate({
                scrollTop: $targetElement.offset().top - headerHeight
            }, 500);
        }
    }
    $(window).on('hashchange', function() {
        scrollToHash(window.location.hash);
    });

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }
  }
});



/*$(document).ready(function() {
  $('.mega-menu').hover(
    function() { // Mouse enters
      var content = $(this).find('.mega-menu__content');
      content.stop(true, true).fadeIn(300); // Fade in over 200 milliseconds
    },
    function() { // Mouse leaves
      var content = $(this).find('.mega-menu__content');
      setTimeout(function() {
        if (!content.is(':hover')) {
          content.stop(true, true).fadeOut(300); // Fade out over 200 milliseconds
        }
      }, 100); // Optional delay before fading out
    }
  );
});
*/
